import { memo } from 'react'
import { NodeProps, useReactFlow } from 'reactflow'
import { useShallow } from 'zustand/react/shallow'

import { NodeTypeEnum } from '@ui/interfaces'
import { useNavigateToNode } from '@ui/lib/hooks/useNavigateToNode'
import { FeatureFlagName, useFeatureFlag } from '@ui/providers/FeatureFlagProvider'
import { useLayoutPanelManagerStore, useNodeAndEdgeStore } from '@ui/stores/pipelinesWorkflow'

import { LayoutPanel, RIGHT_PANEL_CONTENT } from '../PipelineLayoutManager'
import { NodeContainer } from './NodeContainer'
import { NodeContainerV2 } from './NodeContainerV2'

export const TransformationNode = memo((node: NodeProps) => {
  const workflowUpdateEnabled = useFeatureFlag(FeatureFlagName.WorkflowUpdate)

  const { fitView } = useReactFlow()
  const navigateToNode = useNavigateToNode()

  const { currentNodeId, setCurrentNodeId, nodes } = useNodeAndEdgeStore(
    useShallow((state) => ({
      currentNodeId: state.currentNodeId,
      setCurrentNodeId: state.setCurrentNodeId,
      nodes: state.nodes,
    }))
  )

  const { setPanelContent } = useLayoutPanelManagerStore(
    useShallow((state) => ({
      setPanelContent: state.setPanelContent,
    }))
  )

  const onClick = () => {
    setCurrentNodeId(node.id)

    const currentNode = nodes.find((n) => n.id === node.id)
    fitView({ nodes: [currentNode!], duration: 400, maxZoom: 1.5, padding: 0.5 })

    setPanelContent({
      panel: LayoutPanel.RIGHT_PANEL,
      content: RIGHT_PANEL_CONTENT.TRANSFORMATION_STEPS,
      open: true,
    })
    setPanelContent({
      panel: LayoutPanel.INNER_RIGHT_PANEL,
      content: null,
      open: false,
    })

    navigateToNode(node.id)
  }

  if (workflowUpdateEnabled) {
    return (
      <NodeContainerV2
        nodeIsSelected={currentNodeId === node.id}
        nodeType={NodeTypeEnum.TRANSFORM}
        node={node}
        onClick={onClick}
      />
    )
  }

  return <NodeContainer nodeIsSelected={false} nodeType={NodeTypeEnum.TRANSFORM} node={node} onClick={onClick} />
})
